import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { EntityModel } from '@data-layer/models/entities';
import { InvoiceModel } from '@data-layer/models/entry-summaries';
import { take } from 'rxjs/operators';
import { IsfStateService } from '../../services';

@Component({
  selector: 'desktop-hts-sidebar',
  template: `
    <desktop-shipment-details-hts
      [isSideBar]="true"
      [disableMFEdit]="true"
      [manufacturers]="manufacturers"
      [invoices]="invoices"
      (dataSaved)="onSavedData()"
    ></desktop-shipment-details-hts>
  `,
  styleUrls: ['./desktop-hts-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopHtsSidebarComponent implements OnInit {
  @Input() public entityId: number;
  @Input() public invoiceId: number;
  @Output() public dataSaved: EventEmitter<void> = new EventEmitter<void>();

  public manufacturers: EntityModel[];
  public invoices: InvoiceModel[];

  constructor(public isfStateService: IsfStateService) {}

  public ngOnInit(): void {
    this.manufacturers = (this.isfStateService.getIsfManufacturerEntityList() || []).filter((item) => item.id === this.entityId);
    this.invoices = (this.isfStateService.getIsfInvoicesList() || []).filter((item) => item.id === this.invoiceId);
  }

  public onSavedData(): void {
    this.isfStateService
      .getSummaryById(this.isfStateService.currentIsf.referenceNumber)
      .pipe(take(1))
      .subscribe((isf) => {
        // due to complicated logic we have to get the whole ISF
        this.isfStateService.currentIsf = isf;
        this.dataSaved.emit();
      });
  }
}
